// tslint:disable
export enum RoleType {
    /**
     * @description Unknown
     */
    Unknown = 0,
    /**
     * @description Patient
     */
    Patient = 1,
    /**
     * @description Prescriber
     */
    Prescriber = 2,
    /**
     * @description Insurance Provider
     */
    InsuranceProvider = 3,
    /**
     * @description Pharmacy Benefit Manager
     */
    PharmacyBenefitManager = 4,
    /**
     * @description Secondary Contact
     */
    SecondaryContact = 5,
    /**
     * @description Manufacturer
     */
    Manufacturer = 6,
    /**
     * @description Employee
     */
    EMP = 7,
    /**
     * @description Customer Service Rep
     */
    CustomerServiceRep = 8,
    /**
     * @description Prescriber Site
     */
    PrescriberSite = 9,
    /**
     * @description Brand
     */
    Brand = 10,
    /**
     * @description Child
     */
    Child = 11,
    /**
     * @description Social Worker
     */
    SocialWorker = 12,
    /**
     * @description Financial Representative
     */
    FinancialRepresentative = 13,
    /**
     * @description Legal Representative
     */
    LegalRepresentative = 14,
    /**
     * @description Corporate
     */
    Corporate = 15,
    /**
     * @description Personal Contact
     */
    PersonalContact = 16,
    /**
     * @description Spouse
     */
    Spouse = 17,
    /**
     * @description Parent
     */
    Parent = 18,
    /**
     * @description Home Health
     */
    HomeHealth = 19,
    /**
     * @description Alternate Contact
     */
    AlternateContact = 20,
    /**
     * @description Auto Injury Plan
     */
    AutoInjuryPlan = 21,
    /**
     * @description Commercial Plan
     */
    CommercialPlan = 22,
    /**
     * @description Federal Employee Program
     */
    FederalEmployeeProgram = 23,
    /**
     * @description Medicaid
     */
    Medicaid = 24,
    /**
     * @description Medicare Advantage
     */
    MedicareAdvantage = 25,
    /**
     * @description Medicare B
     */
    MedicareB = 26,
    /**
     * @description Medicare D
     */
    MedicareD = 27,
    /**
     * @description Medi-Gap
     */
    MediGap = 28,
    /**
     * @description VA/DoD/TRICARE
     */
    VADoDTRICARE = 29,
    /**
     * @description Workers Compensation
     */
    WorkersCompensation = 30,
    /**
     * @description Plan
     */
    Plan = 31,
    /**
     * @description Payer
     */
    Payer = 32,
    /**
     * @description Durable Medical Equiqment Plan
     */
    DurableMedicalEquiqmentPlan = 33,
    /**
     * @description Managed Care Medicaid Plan
     */
    ManagedCareMedicaidPlan = 34,
    /**
     * @description State Pharmacy Assistance Program
     */
    StatePharmacyAssistanceProgram = 35,
    /**
     * @description Medicare Part A&B Plan
     */
    MedicarePartABPlan = 36,
    /**
     * @description Aids Drug Assistance Program
     */
    AidsDrugAssistanceProgram = 37,
    /**
     * @description State Plan
     */
    StatePlan = 38,
    /**
     * @description Provider
     */
    Provider = 39,
    /**
     * @description Exclusive Provider Organization
     */
    ExclusiveProviderOrganization = 40,
    /**
     * @description Indemnity Insurance
     */
    IndemnityInsurance = 41,
    /**
     * @description Health Maintenance Organization
     */
    HealthMaintenanceOrganization = 42,
    /**
     * @description Point of Service Plan
     */
    PointOfServicePlan = 43,
    /**
     * @description Preferred Provider Organization
     */
    PreferredProviderOrganization = 44,
    /**
     * @description Self
     */
    Self = 45,
    /**
     * @description Office Contact
     */
    OfficeContact = 46,
    /**
     * @description Pharmacy
     */
    Pharmacy = 47,
    /**
     * @description Medicare A
     */
    MedicareA = 48,
    /**
     * @description Hospital
     */
    Hospital = 49,
    /**
     * @description Hospital Outpatient
     */
    HospitalOutpatient = 50,
    /**
     * @description Infusion Center
     */
    InfusionCenter = 51,
    /**
     * @description Retail Pharmacy
     */
    RetailPharmacy = 52,
    /**
     * @description Foundation
     */
    Foundation = 53,
    /**
     * @description Secondary/Supplemental
     */
    SecondarySupplemental = 54,
    /**
     * @description Registered Nurse
     */
    RegisteredNurse = 55,
    /**
     * @description Licensed Practical Nurse
     */
    LicensedPracticalNurse = 56,
    /**
     * @description Certified Nursing Assistant
     */
    CertifiedNursingAssistant = 57,
    /**
     * @description Medical Assistant
     */
    MedicalAssistant = 58,
    /**
     * @description National Home Health Agency
     */
    NationalHomeHealthAgency = 59,
    /**
     * @description Independent Home Health Agency
     */
    IndependentHomeHealthAgency = 60,
    /**
     * @description Practice
     */
    Practice = 61,
    /**
     * @description Per Diem/Contract Individual
     */
    PerDiemContractIndividual = 62,
    /**
     * @description Employee
     */
    Employee = 63,
    /**
     * @description Dual Eligible Plan
     */
    DualEligiblePlan = 64,
}
(RoleType as any)['UNKNOWN'] = 0;
(RoleType as any)['PATIENT'] = 1;
(RoleType as any)['PRESCRIBER'] = 2;
(RoleType as any)['INSURANCEPROVIDER'] = 3;
(RoleType as any)['PHARMACYBENEFITMANAGER'] = 4;
(RoleType as any)['SECONDARYCONTACT'] = 5;
(RoleType as any)['MANUFACTURER'] = 6;
(RoleType as any)['CUSTOMERSERVICEREP'] = 8;
(RoleType as any)['PRESCRIBERSITE'] = 9;
(RoleType as any)['BRAND'] = 10;
(RoleType as any)['CHILD'] = 11;
(RoleType as any)['SOCIALWORKER'] = 12;
(RoleType as any)['FINANCIALREPRESENTATIVE'] = 13;
(RoleType as any)['LEGALREPRESENTATIVE'] = 14;
(RoleType as any)['CORPORATE'] = 15;
(RoleType as any)['PERSONALCONTACT'] = 16;
(RoleType as any)['SPOUSE'] = 17;
(RoleType as any)['PARENT'] = 18;
(RoleType as any)['HOMEHEALTH'] = 19;
(RoleType as any)['ALTERNATECONTACT'] = 20;
(RoleType as any)['AUTOINJURYPLAN'] = 21;
(RoleType as any)['COMMERCIALPLAN'] = 22;
(RoleType as any)['FEDERALEMPLOYEEPROGRAM'] = 23;
(RoleType as any)['MEDICAID'] = 24;
(RoleType as any)['MEDICAREADVANTAGE'] = 25;
(RoleType as any)['MEDICAREB'] = 26;
(RoleType as any)['MEDICARED'] = 27;
(RoleType as any)['MEDIGAP'] = 28;
(RoleType as any)['VADODTRICARE'] = 29;
(RoleType as any)['WORKERSCOMPENSATION'] = 30;
(RoleType as any)['PLAN'] = 31;
(RoleType as any)['PAYER'] = 32;
(RoleType as any)['DURABLEMEDICALEQUIQMENTPLAN'] = 33;
(RoleType as any)['MANAGEDCAREMEDICAIDPLAN'] = 34;
(RoleType as any)['STATEPHARMACYASSISTANCEPROGRAM'] = 35;
(RoleType as any)['MEDICAREPARTABPLAN'] = 36;
(RoleType as any)['AIDSDRUGASSISTANCEPROGRAM'] = 37;
(RoleType as any)['STATEPLAN'] = 38;
(RoleType as any)['PROVIDER'] = 39;
(RoleType as any)['EXCLUSIVEPROVIDERORGANIZATION'] = 40;
(RoleType as any)['INDEMNITYINSURANCE'] = 41;
(RoleType as any)['HEALTHMAINTENANCEORGANIZATION'] = 42;
(RoleType as any)['POINTOFSERVICEPLAN'] = 43;
(RoleType as any)['PREFERREDPROVIDERORGANIZATION'] = 44;
(RoleType as any)['SELF'] = 45;
(RoleType as any)['OFFICECONTACT'] = 46;
(RoleType as any)['PHARMACY'] = 47;
(RoleType as any)['MEDICAREA'] = 48;
(RoleType as any)['HOSPITAL'] = 49;
(RoleType as any)['HOSPITALOUTPATIENT'] = 50;
(RoleType as any)['INFUSIONCENTER'] = 51;
(RoleType as any)['RETAILPHARMACY'] = 52;
(RoleType as any)['FOUNDATION'] = 53;
(RoleType as any)['SECONDARYSUPPLEMENTAL'] = 54;
(RoleType as any)['REGISTEREDNURSE'] = 55;
(RoleType as any)['LICENSEDPRACTICALNURSE'] = 56;
(RoleType as any)['CERTIFIEDNURSINGASSISTANT'] = 57;
(RoleType as any)['MEDICALASSISTANT'] = 58;
(RoleType as any)['NATIONALHOMEHEALTHAGENCY'] = 59;
(RoleType as any)['INDEPENDENTHOMEHEALTHAGENCY'] = 60;
(RoleType as any)['PRACTICE'] = 61;
(RoleType as any)['PERDIEMCONTRACTINDIVIDUAL'] = 62;
(RoleType as any)['EMPLOYEE'] = 63;
(RoleType as any)['DUALELIGIBLEPLAN'] = 64;
